module.exports = __webpack_public_path__ + "static/media/problem.eede4b92.svg";